import Styles from './Carousels.module.scss'
import { SectionHeader } from './SectionHeader'
import { BrandKit as BrandKitType } from 'types'
import { MediaFileCarousel } from './MediaFileCarousel'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { UploadedMediaCarouselProps } from '../Types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { BrandKitDrawer } from '../Grids/BrandKitDrawer'
import { useMediaPickerContext } from '../MediaPickerContext'

interface Props extends UploadedMediaCarouselProps {
  brandKit: BrandKitType
}

export const BrandKit = observer(({ brandKit, accept }: Props) => {
  const { openDrawer } = useRootStore().drawersStore
  const { handleSelect } = useMediaPickerContext()
  const mediaFiles = brandKit.media_files.filter((mediaFile) => accept.includes(mediaFile.mime_type))
  const title = brandKit?.name || 'Brand Kit'

  if (mediaFiles.length === 0) return null

  const openBrandKitDrawer = () => {
    openDrawer(BrandKitDrawer, { brandKit, accept, onSelect: handleSelect, title })
  }

  return (
    <MobileWizard.Section gap={8}>
      <SectionHeader title={`${title} Brand Kit`} onPress={openBrandKitDrawer} />
      <div className={Styles.sectionContainer}>
        <MediaFileCarousel mediaFiles={mediaFiles} provider="brandKits" />
      </div>
    </MobileWizard.Section>
  )
})
